import ApiService from '@/services/api.service.js';
import store from '@/store/index.js';

export default function useDistributionKeyPeriodRepository(clientId) {
  const appsettings = store.state.appSettings;
  const isNotEmpty = (value) => value !== undefined && value !== null && value !== '';

  const load = (loadOptions) => {
    let params = '?';

    [
      'filter',
      'group',
      'groupSummary',
      'parentIds',
      'requireGroupCount',
      'requireTotalCount',
      'searchExpr',
      'searchOperation',
      'searchValue',
      'select',
      'sort',
      'skip',
      'take',
      'totalSummary',
      'userData',
    ].forEach((i) => {
      if (i in loadOptions && isNotEmpty(loadOptions[i])) {
        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
      }
    });
    params = params.slice(0, -1);

    return ApiService
      .get(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/distributionkeys/${clientId}/periods/overview${params}`);
  };

  const update = (key, values) => ApiService
    .put(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/distributionkeys/${clientId}/periods/${key}`, { values: JSON.stringify(values) });

  const insert = (values) => ApiService
    .post(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/distributionkeys/${clientId}/periods`, { values: JSON.stringify(values) });

  const remove = (key) => ApiService
    .delete(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/distributionkeys/${clientId}/periods/${key}`);

  const toggleActivateState = (key, value) => {
    const data = {
      value,
    };
    return ApiService
      .put(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/distributionkeys/${clientId}/periods/${key}/toggleactive`, data);
  };

  const copy = (key, payload) => ApiService
    .post(`${appsettings.ADMINISTRATION_API}/api/v1/masterdata/distributionkeys/${clientId}/periods/${key}/copy`, payload);

  return {
    load,
    update,
    insert,
    remove,
    toggleActivateState,
    copy,
  };
}
